import React from "react";
import styled from "styled-components";

import { SegmentedRow, SegmentedButton } from "../common/SegmentedButtons";

/** The span of days the chart shows around the issue start. */
export default function Zoom({ zooms, zoom, onZoom }) {
    return (
        <Wrap>
            <Label id="deep-dive-zoom">Chart shows</Label>
            <SegmentedRow role="group" aria-labelledby="deep-dive-zoom">
                {zooms.map(({ key, label }) => (
                    <SegmentedButton key={key} type="button" aria-pressed={key === zoom.key} $active={key === zoom.key} onClick={() => onZoom(key)}>
                        {label}
                    </SegmentedButton>
                ))}
            </SegmentedRow>
        </Wrap>
    );
}

const Wrap = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

const Label = styled.span`
    font-size: 0.74rem;
    font-weight: 600;
    color: #64748b;
`;
